import { Grid } from '@mui/material'
import PaymentDialogMobileContent from '../PaymentDialogMobileContent'
import CalculatePanel from 'components/Sell/CalculationInput/CalculatePanel'
import PaymentMobileDetail from '../PaymentMobileDetail'
import FinishPaymentButton from '../FinishPaymentButton'
import usePaymentContext from 'components/Sell/payment/hook/usePaymentContext'
import { usePaymentCalculation } from 'components/Sell/payment/hook/usePaymentCalculation'

function CashMobilePayment({
    onBack,
    onSubmitPayment,
}: {
    onBack: () => void
    onSubmitPayment: () => void
}) {
    const {
        selectedPaymentType,
        expectAmount,
        payment,
        isReadyToProceedPayment,
        onOpenAccountDialog,
        paymentDetail,
        tenderedAmount,
        onSetReceivedCash,
        onSetTenderedAmount,
    } = usePaymentContext()

    const { isMoneyCollect } = usePaymentCalculation({
        selectedPaymentType,
        expectAmount,
        payment,
    })

    return (
        <PaymentDialogMobileContent
            onBack={onBack}
            topSection={
                <Grid container direction="column" spacing={1}>
                    <Grid item>
                        <CalculatePanel
                            paymentDetail={paymentDetail}
                            initialValue={tenderedAmount.toNumber()}
                            onChange={(amount) => {
                                onSetReceivedCash(amount)
                                onSetTenderedAmount(amount)
                            }}
                            onChangeCustomerAccount={onOpenAccountDialog}
                            hideQuickButtons
                            minValue={0}
                        />
                    </Grid>
                </Grid>
            }
            bottomSection={<PaymentMobileDetail />}
            finishButton={
                <FinishPaymentButton
                    onConfirm={onSubmitPayment}
                    onCancel={onBack}
                    isMoneyCollect={isMoneyCollect}
                    isReadyToProceedPayment={isReadyToProceedPayment}
                />
            }
        />
    )
}
export default CashMobilePayment
